import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import _get from 'lodash/get';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Hidden from '@material-ui/core/Hidden';
import SeeAllLink from 'components/SeeAllLink';
import _isEmpty from 'lodash/isEmpty';
import AppContainer from 'components/AppContainer';
import Carousel from 'components/Carousel';
import CarouselContainer from 'components/Carousel/CarouselContainer';
import useWindowSize from 'components/useWindowSize';
import {
  makeStyles,
  MuiThemeProvider,
  createTheme,
  useTheme,
} from '@material-ui/core/styles';
import ListTitle from 'components/ListTitle';
import { makeSelectHomeHeaders } from 'containers/Main/selectors';
import BlogItem from 'containers/Blogs/components/BlogItem';
import { makeSelectBlogs } from '../selectors';
import { getHomeBlogs } from '../actions';

const customBreakpoints = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1024,
      lg: 1280,
      xl: 1920,
    },
  },
};

const useStyles = makeStyles({
  container: {
    marginTop: 54,
  },
  viewMore: {
    display: 'flex',
    justifyContent: 'center',
  },
  link: {
    textDecoration: 'none',
  },
  titleWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  blogItemHeight: {
    height: '310px',
  },
});

function OriginalsList({ grayscale }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const homeHeaders = useSelector(makeSelectHomeHeaders());
  const blogs = useSelector(makeSelectBlogs());
  const currentTheme = useTheme();
  const theme = createTheme({ ...currentTheme, ...customBreakpoints });
  const { width } = useWindowSize();
  const isMobile = width <= 600;

  useEffect(() => {
    dispatch(getHomeBlogs());
  }, [dispatch]);

  if (_isEmpty(blogs)) {
    return null;
  }
  const title = _get(homeHeaders, 'pageCopy.blogs');
  const linkLabel = _get(homeHeaders, 'pageCopy.blogsLinkLabel');
  const customProps = isMobile ? { centerMode: true } : null;
  return (
    <MuiThemeProvider theme={theme}>
      <div className={classes.container}>
        <AppContainer topPadding={isMobile}>
          <Hidden xsDown>
            <Grid item xs={12}>
              <Grid container direction="row" justifyContent="space-between">
                <Grid item xs={12} sm={8}>
                  <ListTitle title={title} />
                </Grid>
                <Hidden xsDown>
                  <SeeAllLink link="insights" label={linkLabel} />
                </Hidden>
              </Grid>
            </Grid>
            <Grid item container spacing={2}>
              {blogs.map((item, index) =>
                index === 0 ? (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    key={_get(item, 'fields.slug')}
                  >
                    <Box className={classes.blogItemHeight}>
                      <BlogItem fields={item.fields} grayscale={grayscale} />
                    </Box>
                  </Grid>
                ) : (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    key={_get(item, 'fields.slug')}
                  >
                    <Box className={classes.blogItemHeight}>
                      <BlogItem fields={item.fields} grayscale={grayscale} />
                    </Box>
                  </Grid>
                ),
              )}
            </Grid>
          </Hidden>
          <Hidden smUp>
            <Grid item xs={12} className={classes.titleWrapper}>
              <ListTitle title={title} />
            </Grid>
            <CarouselContainer>
              <Carousel slideToShow={1} customProps={customProps}>
                {blogs.map(item => (
                  <BlogItem
                    fields={item.fields}
                    key={_get(item, 'fields.slug')}
                    grayscale={grayscale}
                  />
                ))}
              </Carousel>
            </CarouselContainer>
            <Grid item xs={12} className={classes.viewMore}>
              <SeeAllLink link="insights" isMobile bordered align="center" />
            </Grid>
          </Hidden>
        </AppContainer>
      </div>
    </MuiThemeProvider>
  );
}

OriginalsList.propTypes = {
  grayscale: PropTypes.bool,
};

export default OriginalsList;
